
  
  import { ModelSelect, ModelListSelect  } from 'vue-search-select'
  import 'vue-search-select/dist/VueSearchSelect.css'
  
  
  import UMUM from '../../library/umum'
  import DATAMASTER from '../../library/dataMaster'
  import FETCHING from '../../library/fetching'

  
  
  import Joi from "joi";
  
  const schema = Joi.object().keys({
      username: Joi.string().regex(/^[a-zA-Z0-9_]*$/).min(6).max(13).required(),
      password: Joi.string().min(6).required(),
    });
  
  
  
  export default {
    components: {
        ModelSelect, ModelListSelect, 
    },
  
    data() {
      return {
  
        status:'',
        
  
        form : {
          id : '',
          judul : '',
          des_kel_id : '',
          nama_des_kel : '',
        },
        


        chat : [
              // {
              // name : 'riswan',
              // text: ['doing fine, how r you?'],
              // sent: true

              // },
              // {
              // name : 'indra',
              // text: ['i am okay?'],
              // sent:false
              // },

              // {
              // name : 'riswan',
              // text: ['salah'],
              // sent: true
              // },


              ],
  
         lampiran : {
            id : '',
            konsultasi_id : '',
            kegiatan_id : '',
            des_kel_id : '',
            uraian : '',
            tahun : '',
            keterangan : '',
            file : null,
            file_type : '',
             file_old : null,
          },
  
  
          filterku : {
            tahun : '',
            des_kel_id : '',
            kecamatan_id : '',
            program_id : '',
        },
      
        list_data : [],
  
        errorMessage: '',
        signingUp : false,
      
        UMUM : UMUM,
        
        DATAMASTER : DATAMASTER,
        FETCHING : FETCHING,
  
  
        page_first: 1,
        page_last: 0,
        page_limit : 10,
        cari_value: "",
  
        cek_load_data : true,
  
  
        mdl_add: false,
        mdl_edit: false,
        mdl_edit_file: false,
        mdl_hapus : false,
        mdl_hapus_asn : false,
        mdl_hapus_lampiran : false,
        mdl_add_file : false,
        mdl_add_kgb : false,
        
        mdl_lihat : false,
        mdl_list : false,
        mdl_open : false,
        mdl_open_kgb : false,
        mdl_list_hasil : false,
        mdl_keterangan : false,
        mdl_keterangan_folder : false,
  
  
        mdl_list_direktori: false,
  
        file_path: this.$store.state.url.URL_APP + "uploads/",


        list_program : [],

        list_kegiatan : [],
  
  
        tipe: 0,
        cariNamaPegawai : '',
        list_kgb_asn : [],
        list_lampiran : [],
        list_hasil:[],
      }
    },
    methods: {
  

      getView : function(){
        this.cek_load_data = true;
        fetch(this.$store.state.url.URL_KON + "view", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({
                data_ke: this.page_first,
                cari_value: this.cari_value,
                page_limit : this.page_limit,
                kecamatan_id : this.filterku.kecamatan_id,
                des_kel_id : this.filterku.des_kel_id,
                tipeku : this.tipeku,
            })
        })
            .then(res => res.json())
            .then(res_data => {

                this.list_data = res_data.data;
                this.page_last = res_data.jml_data;
                this.cek_load_data = false;
                console.log(this.list_data + "siap");
        });
      },

      getChat : function(){
        this.cek_load_data = true;
        fetch(this.$store.state.url.URL_KON + "viewChat", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({
                data_ke: this.page_first,
                cari_value: this.cari_value,
                page_limit : this.page_limit,
                kecamatan_id : this.filterku.kecamatan_id,
                des_kel_id : this.filterku.des_kel_id,
                tipeku : this.tipeku,
                konsultasi_id : this.lampiran.konsultasi_id
            })
        })
            .then(res => res.json())
            .then(res_data => {

                this.chat = res_data;
                console.log(this.chat);
        });
      },


      addData : function() {
        
            fetch(this.$store.state.url.URL_KON + "addData", {
                method: "POST",
                headers: {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
                },
                body: JSON.stringify({
                form : this.form,
            })
                
            }).then(res_data => {
            this.getView();
            this.Notify ('Sukses Menambah Data', 'primary', 'check_circle_outline');
            });


        },


        jam : function(tgl) {
          var date = new Date(tgl);
          return date.toLocaleTimeString();
        },
        

      addChat : function() {

            fetch(this.$store.state.url.URL_KON + "addChat", {
                method: "POST",
                headers: {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
                },
                body: JSON.stringify({
                'name': `${this.username}`,
                'textku': `${this.pesan}`,
                tipeku : this.tipeku,
                des_kel_id : this.filterku.des_kel_id,
                nama_des_kel : this.form.nama_des_kel,
                konsultasi_id : this.lampiran.konsultasi_id,
            })
                
            }).then(res_data => {
            this.getChat();
            // this.Notify ('Sukses Menambah Data', 'primary', 'check_circle_outline');
            });


        },

      editData: function() {
          fetch(this.$store.state.url.URL_KON + "editData", {
              method: "POST",
              headers: {
                  'content-type' : 'application/json',
                  authorization: "kikensbatara " + localStorage.token
              },
              body: JSON.stringify({
              form : this.form
            })
          }).then(res_data => {
              this.Notify('Sukses Mengubah Data', 'primary', 'check_circle_outline');
              this.getView();
          });
      },
  
      removeData : function(idnya){
        fetch(this.$store.state.url.URL_KON + "removeData", {
              method: "POST",
              headers: {
                  "content-type": "application/json",
                  authorization: "kikensbatara " + localStorage.token
              },
              body: JSON.stringify({id : this.form.id})
          }).then(res_data => {
              this.Notify('Sukses Menghapus Data', 'negative', 'check_circle_outline');
            this.getView();
          });
      },
  
     
      
  
      selectData : function(data){
          // console.log(data)
          this.form.id = data.id;
          this.form.konsultasi_id = data.konsultasi_id;
          this.form.kegiatan_id = data.kegiatan_id;
          this.form.tahun = data.tahun;
          this.form.keterangan = data.keterangan;
          this.form.des_kel_id = data.des_kel_id;
          this.form.nama_des_kel = data.nama_des_kel;
      },
  
        select2(data){
          
          this.lampiran.konsultasi_id = data.id
          this.lampiran.kegiatan_id = data.kegiatan_id
          this.lampiran.des_kel_id = data.des_kel_id
          this.lampiran.tahun = data.tahun
          
          
          
          this.getChat();
          this.getLampiran(data.id);
        },
  
  
        selectLampiran : function(data){
          // console.log(data.file + "asubabi");
          
          this.lampiran.id = data.id;
          // this.lampiran.direktori_id = data.direktori_id;
          this.lampiran.des_kel_id = data.des_kel_id;
          this.lampiran.konsultasi_id = data.konsultasi_id;
          this.lampiran.keterangan = data.keterangan;
          this.lampiran.file_old =  data.file
          this.lampiran.file = this.lampiran.file
          },
  
        getLampiran : function(direktori){
  
          fetch(this.$store.state.url.URL_PAJAK + "viewLampiran", {
              method: "POST",
              headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
              },
              body: JSON.stringify({
                  direktori_id : direktori,
                  des_kel_id :  this.lampiran.des_kel_id,
                  konsultasi_id :  this.lampiran.konsultasi_id,
              })
          })
              .then(res => res.json())
              .then(res_data => {
                console.log("asgdajhsda" + res_data)
                this.list_lampiran = res_data
          });
        },
  
    
  
  
  
  
            editLampiran: function(){
  
            var formData = new FormData();
            formData.append('pb', JSON.stringify(this.lampiran));
            formData.append('file', this.lampiran.file);
            // formData.append('fileOld', this.fileOld);
  
            fetch(this.$store.state.url.URL_PAJAK + 'editDataLampiran', {
                method: "POST",
                headers: {
                    authorization: "kikensbatara " + localStorage.token
                },
                body: formData
                }).then(res_data => {
                  this.Notify('Sukses Mengubah Data', 'primary', 'check_circle_outline');
                  var a = this.lampiran.direktori_id
                  var b = this.lampiran.kegiatan_id 
                  this.getLampiran(a, b); 
            });
            },


            // ====================================== CONTOH eDOC ====================================
      async onChangexKecamatan(){
        
        
        await DATAMASTER.getKecamatanAsync("");
        this.onChangexDeskel();
      },
      async onChangexDeskel(){
        // console.log("yyyyyyyyyyyy");
        var deskelx = await DATAMASTER.getDeskelAsync(this.filterku.kecamatan_id)
        // console.log("xxxxxxxxxxxxx");
        // console.log(deskelx[0].id);
      
          // this.filterku.des_kel_id = deskelx[0].id
        
        
        // console.log("xxxxxxxxxxxxx");
        // console.log(this.filterku.des_kel_id);
        this.getView();
      },
  
      // ====================================== PAGINATE ====================================
          Notify : function(message, positive, icon){
            this.$q.notify({
              message: message,
              color: positive,
              icon: icon,
              position : 'top',
              timeout: 500,
            })
          },
  
          indexing : function(index){
              var idx = ((this.page_first-1)*this.page_limit)+index
              return idx;
          },
  
          selectFolder : function(data){ 
           this.folder.id = data.id;
            this.folder.status = data.status;
            this.folder.notice = data.notice;
  
        },
  
  
  
          cari_data : function(){
              this.page_first = 1;
              this.getView();
          },
  
          selectBiodata (item) {
            return `${item.nama} | NIP. ${item.nip}`
          },
  
  
          getAsyncPost : async function() {
            this.list_klp = await FETCHING.postMasterKlpMenu();
          },
  
          cariNama : async function(){
            this.$store.state.list_biodata = await FETCHING.FETCH_POST(this.$store.state.url.URL_simpeg_biodata + "cariNama", {cari : this.cariNamaPegawai, unit_kerja : this.unit_kerja} )
            this.getView()
          },
  
      // ====================================== PAGINATE ====================================
    },
  
    mounted () {

    let profilex = JSON.parse(localStorage.profile);
    let profile = profilex.profile;
    DATAMASTER.getDeskelAsync(this.filterku.des_kel_id);
    this.form.des_kel_id = profile.des_kel_id;

    
    
    this.filterku.des_kel_id = profile.des_kel_id;
    this.tipeku = profile.menu_klp;
    
    if (this.tipeku==1) {
      this.filterku.kecamatan_id = ""
      
      
    } else {
      
      this.filterku.kecamatan_id = profile.kecamatan_id;

    }
    
    
    this.username = profile.username;
    this.form.nama_des_kel = profile.nama_des_kel;

    //   console.log("======" + this.filterku.des_kel_id);
      

      const d = new Date();
      let year = d.getFullYear();
      this.form.tahun = year;
      this.filterku.tahun = year;

    //   console.log(profile)


      DATAMASTER.getTahun();


      this.onChangexKecamatan();
      // this.getChat();
      // this.getProgram();
    //   this.getKegiatan();


  
    },
  }
  